export default function BuzzControls({
  phase = "ready",
  onBuzz,
  onPass,
  disabled = false,
  passDisabled = false,
  className = "",
}) {
  const isReading = phase === "reading";
  const isBuzzable = phase === "buzzable";
  const isLocked = disabled;

  const buzzCanBePressed =
    (isReading || isBuzzable) && !isLocked;

  const passEnabled =
    (isReading || isBuzzable) &&
    !isLocked &&
    !passDisabled;

  const buzzLabel = isLocked
    ? "LOCKED"
    : isBuzzable
      ? "BUZZ"
      : isReading
        ? "WAIT"
        : "BUZZ";

  const containerClass = [
    "buzz-controls",
    `buzz-controls--${phase}`,
    isLocked && "buzz-controls--locked",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClass}>
      <div className="buzz-controls__buttons">
        <button
          type="button"
          className="buzz-controls__buzz-button"
          onClick={onBuzz}
          disabled={!buzzCanBePressed}
          aria-label={
            isLocked
              ? "Buzzer temporarily locked"
              : isBuzzable
                ? "Buzz now"
                : "Wait. Buzzing now will be too early"
          }
        >
          <span className="buzz-controls__buzz-core">
            {buzzLabel}
          </span>
        </button>

        <button
          type="button"
          className="buzz-controls__pass-button"
          onClick={onPass}
          disabled={!passEnabled}
        >
          Pass
        </button>
      </div>
    </div>
  );
}